import Link from "../components/link"
import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { toggleMenu } from "../lib/toggleMenu"
import NewsletterForm from "../components/newsletterForm"
import { trackHubSpotFormSubmit } from "../utils/trackFormSubmit"

const AddressLines = ({ text }) =>
  (text || "").split("\n").map((line, index, lines) => (
    <React.Fragment key={index}>
      {line}
      {index < lines.length - 1 && <br />}
    </React.Fragment>
  ))

const Footer = ({ footerClassName, clicked }) => {

  const { datoCmsContactInformation: contact } = useStaticQuery(graphql`
    query FooterContact {
      datoCmsContactInformation {
        addressOneTitle
        addressOne
        addressOneLink
        addressTwoTitle
        addressTwo
        addressTwoLink
      }
    }
  `)

  useEffect(() => {
    document.querySelector('.cta--trigger').addEventListener("click", toggleMenu);
    window.hbspt.forms.create({
      region: "na1",
      portalId: "9226978",
      formId: "da19a315-f025-49d3-a70f-5a512d5395c8",
      target: "#footer-form",
      onFormSubmit: ($form) => {
        const email = ($form && $form.find && $form.find('input[name="email"]').val())
          || (document.querySelector('#footer-form input[name="email"]') || {}).value
        trackHubSpotFormSubmit({
          email,
          formGuid: "da19a315-f025-49d3-a70f-5a512d5395c8",
          formName: "footer_newsletter",
        })
      },
    })
  }, [])

  const Contact = ({className}) => {
    return (
      <div className={"social-accounts caption m-mb10 " + className}>
        <a className="link ul-link mr20 footer--small--text" target="_blank" rel="noreferrer" href="https://www.instagram.com/sieragroup/">Instagram<span className="sr-only"> (opens in new tab)</span></a>

        <a className="link ul-link mr20 footer--small--text" target="_blank" rel="noreferrer" href="https://www.facebook.com/sieragroup">Facebook<span className="sr-only"> (opens in new tab)</span></a>
        <a className="link ul-link mr20 footer--small--text" target="_blank" rel="noreferrer" href="https://www.youtube.com/channel/UCvCNr4mtCh0Ob4nwH_7RStA">Youtube<span className="sr-only"> (opens in new tab)</span></a>
        <a className="link ul-link footer--small--text" target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/siera-group/">Linkedin<span className="sr-only"> (opens in new tab)</span></a>
      </div>
    )
  }

  return (
    <footer className={"footer p40 m-pb40 m-pt0 " + footerClassName}>
      <div className="max-1400 ma bt1 pt40 flex m-wrap m-pt150">
        <div className="subscribe m-100 mr20">
          <p className="max-250 h2 mt0 mb40 m-mb80 ">Subscribe to our mailing list to stay in touch with the latest</p>
          <div className='w-100' id='footer-form'/>
          <div className="spacer"></div>
          <Contact  className='m-hide'/>
        </div>
        <div className="max-450 mla w-100 m-mla">
          <div className="flex flex-wrap h-100">
            <div className="flex mba w-100 m-wrap">
              <div className="w-50 m-flex m-100">
                <p className="m0 h4 m-w-40 m-flex-grow-1">Menu</p>
                <div className="spacer"></div>
                <div className='links op-50'>
                  <p className="m0 mb5"><Link className="m0 link ul-link" to='/'>Home</Link></p>
                  <p className="m0 mb5"><Link className="m0 link ul-link" to='/developments'>Developments</Link></p>
                  <p className="m0 mb5"><Link className="m0 link ul-link" to='/story'>Our Story</Link></p>
                  <p className="m0 mb5"><Link className="m0 link ul-link" to='/insights'>Insights</Link></p>
                  <p className="m0 mb5"><Link className="m0 link ul-link" to='/news'>News & Articles</Link></p>
                  <p className="m0"><span className="cta--trigger m0 link ul-link">Contact</span></p>
                </div>
              </div>
              <div className="w-50 m-flex m-100 m-mt20 m-mb80">
                <p className="m0 h4 m-w-40 m-flex-grow-1">Location</p>
                <div className="spacer"></div>
                <div className="op-50">
                  <div className="mb20">
                    <p className="m0">{contact?.addressOneTitle}</p>
                    <a href={contact?.addressOneLink} target="_blank" rel="noreferrer" className="location link">
                      <AddressLines text={contact?.addressOne} />
                      <span className="sr-only"> (opens in new tab)</span>
                    </a>
                  </div>
                  <div>
                    <p className="m0">{contact?.addressTwoTitle}</p>
                    <a href={contact?.addressTwoLink} target="_blank" rel="noreferrer" className="location link">
                      <AddressLines text={contact?.addressTwo} />
                      <span className="sr-only"> (opens in new tab)</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <Contact  className='m-show'/>
            <div className="m-spacer"></div>
            <div className="mta w-100 flex  m-wrap ">
              <Link to='/privacy-policy' className="w-50 m-100 m-mb10 link ">
                <span className="caption footer--small--text"> Privacy Policy</span >
               
              </Link>
              <div className="w-50 m-100 link ">
                <span className="caption footer--small--text "> Crafted by </span><a className="link ul-link uppercase footer--small--text" target="_blank" rel="noreferrer" href="https://groundcrew.com.au">Groundcrew<span className="sr-only"> (opens in new tab)</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
